/**
 * macrosProvenance.js
 *
 * Single source of truth for a meal ingredient's `macros_source` provenance in
 * the admin authoring / import UIs. Provenance is set EXPLICITLY through the
 * pipeline — never inferred from whether the per-gram numbers happen to be
 * nonzero (the backend has a matching contract).
 *
 *   'core'   -> the recipe uses Foods Core nutrition as its source
 *   'inline' -> nutrition was intentionally supplied/edited for this recipe
 *               (USDA / custom / hand-edited)
 *   null     -> unknown legacy provenance (kept unclassified so the staging
 *               backfill can classify it safely later)
 */
export const CORE = 'core';
export const INLINE = 'inline';

/** Selecting a Core Food from search => the row uses Foods Core nutrition. */
export function provenanceOnSelectCoreFood() {
  return CORE;
}

/** Any manual edit of a nutrition macro makes the row recipe-specific. */
export function provenanceOnMacroEdit() {
  return INLINE;
}

/**
 * Loading an existing ingredient preserves its stored provenance. A legacy
 * row with no stored provenance stays UNKNOWN (null) — it is NOT guessed.
 */
export function provenanceFromStored(stored) {
  return stored === CORE || stored === INLINE ? stored : null;
}

/**
 * Bulk-import hydration from the dry-run: a row whose nutrition was resolved
 * from Foods Core is 'core'; anything else (unresolved / import-supplied
 * explicit macros) is 'inline'.
 */
export function provenanceOnImportHydrate(resolvedFromCore) {
  return resolvedFromCore ? CORE : INLINE;
}
